<template>

  <nav id="nav" class="navbar navbar-default navbar-full" style="padding: 0px;">
    <div class="container container-nav">
      <div class="navbar-header">
        <button aria-expanded="false" type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs">
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>

      </div>
      <div style="height: 1px;" role="main" aria-expanded="false" class="navbar-collapse collapse" id="bs">
        <ul class="nav navbar-nav navbar-right">
          <li><router-link to="/home">Home</router-link></li>
          <li class="dropdown">
            <a href="javascript:;">QR Code<span class="caret"></span></a>
            <ul class="dropdown-menu">
              <li>
                <a class="link" target="_blank" href="https://chrome.google.com/webstore/detail/qr-code/geabiifdkhmcmhjgoagmlnlgnddooejf?authuser=0">Download chrome extensions</a>
              </li>
              <li><router-link to="/qrcode/apikey">Get API Key</router-link></li>
              <li><router-link to="/qrcode/pricing">Pricing</router-link></li>
            </ul>
          </li>
          <li class="dropdown">
            <a href="javascript:;">Short url<span class="caret"></span></a>
            <ul class="dropdown-menu">
              <li><router-link to="/shorturl/create">Generate short url</router-link></li>
            </ul>
          </li>
          <li><router-link to="/faq">FAQ</router-link></li>
          <li><router-link to="/contact">Contact us</router-link></li>
          <li><router-link to="/about">About us</router-link></li>
<!--          <li><router-link to="/about">Privacy Policy</router-link></li>-->

        </ul>
      </div>



    </div>
    <router-view />
  </nav>


<!--  <div id="more-features-dark" class="container-fluid">-->
<!--    <div class="container">-->
<!--      <div class="row">-->
<!--        <div class="col-md-12">-->
<!--          <div class="row-title" title="Great features">What can i do for you ?</div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="row">-->
<!--        <div class="col-sm-6 col-md-4">-->
<!--          <div class="mfeature-box">-->
<!--            <div class="mfeature-icon">-->
<!--              <div class="icon-bg"><img src="@/assets/picture/cloud-dark.png" alt=""></div>-->
<!--              <div class="icon-img"><img src="@/assets/picture/feature1.png" alt=""></div>-->
<!--            </div>-->
<!--            <div class="mfeature-title">Generate QR code</div>-->
<!--            <div class="mfeature-title"><a class="link" href="/qrcode/apikey">Generate QR code</a></div>-->
<!--            <div class="mfeature-title"><a class="link" target="_blank" href="https://chrome.google.com/webstore/detail/qr-code/geabiifdkhmcmhjgoagmlnlgnddooejf?hl=zh-CN&authuser=0">Install from chrome store</a></div>-->
<!--          </div>-->
<!--        </div>-->


<!--      </div>-->
<!--    </div>-->
<!--  </div>-->

  <div id="footer" class="container-fluid">
    <div class="container">
      <div class="row">

        <div class="col-xs-6 col-sm-3 col-md-3">
          <div class="footer-menu-holder">
            <h4>Company</h4>
            <ul class="footer-menu">
              <li><router-link to="/about">About us</router-link></li>
              <li><router-link to="/faq">FAQ</router-link></li>
            </ul>
          </div>
        </div>

        <div class="col-xs-6 col-sm-3 col-md-3">
          <div class="footer-menu-holder">
            <h4>Services</h4>
            <ul class="footer-menu">
              <li>
                <a class="link" target="_blank" href="https://chrome.google.com/webstore/detail/qr-code/geabiifdkhmcmhjgoagmlnlgnddooejf?authuser=0">QR Code</a>
              </li>
              <li><router-link to="/shorturl/create">Shorten url</router-link></li>
            </ul>
          </div>
        </div>

        <div class="col-xs-6 col-sm-3 col-md-3">
          <div class="footer-menu-holder">
            <h4>Privacy Policy & Disclaimer</h4>
            <ul class="footer-menu">
              <li><router-link to="/privacy/policy">Privacy Policy</router-link></li>
              <li><router-link to="/disclaimer">Disclaimer</router-link></li>
            </ul>
          </div>
        </div>

        <div class="col-xs-6 col-sm-3 col-md-3">
          <div class="footer-menu-holder">
            <h4>Contact us</h4>
            <ul class="footer-menu">
              <li><router-link to="/contact">Contact us</router-link></li>
            </ul>
          </div>
        </div>



      </div>

    </div>
  </div>


</template>

<script>

import { shallowRef } from 'vue';
export default {
  setup () {


    function handleSelect (a, b) {
      console.log('a,b:', a, b);

    }
    return {  handleSelect }
  },

}
</script>


<style scoped>

.menu {
  width: 100%;
  margin: 0 auto;
  /* border: 1px solid #ccc; */
  border: 0;
}


</style>
